var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 24,
    height: 24,
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(6 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M98.691,277.117v3.776H98.4c-.73.007-1.453-.017-2.184.007-.995.031-1.734.414-1.765,1.661-.023.907-.039,3-.039,3s2.343.01,3.36,0h.8c-.19,1.446-.365,2.838-.548,4.245H94.438v10.585h-4.4V289.778H86.451v-4.211h3.616v-.32c0-.849-.015-1.7,0-2.551a11.25,11.25,0,0,1,.135-1.62,4.745,4.745,0,0,1,1.9-3.156,5.521,5.521,0,0,1,3.155-.97c.747-.015,1.494.016,2.234.048C97.9,277.022,98.309,277.077,98.691,277.117Z",
    transform: "translate(-86.451 -276.946)",
    fill: "#5e5e5e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGray);
export default __webpack_public_path__ + "static/media/facebookGray.2a7dbdc3c9ce65e6bc0b5760e1d35071.svg";
export { ForwardRef as ReactComponent };